<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <SharePriceBar/>
    <PageHeader>
      <TextHeading variant="subtitle" color="secondary">Investor</TextHeading>
      <TextHeading variant="xl">Presentations</TextHeading>
    </PageHeader>
    <PageGrid sidebar>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <TextProse>To download recent Annual reviews, Annual reports and financial statements, Quarterly management statements, and Interim and Half-yearly reports, please click on the tab that gives you the year that you want and click on the relevant link.</TextProse>
        <TheFilter/>
        <h3>
          <TextHeading margin>Perlimary Results</TextHeading>
        </h3>
        <GridRow cols="2">
          <GridCol>
            <CardMedia
              doclink="pdf-link-here"
              title="Half Year Results Presentation"
              type="Download PDF"
            />
          </GridCol>
          <GridCol>
            <CardMedia doclink="video-link-here" title="Half Year Results Webcast" type="Watch"/>
          </GridCol>
        </GridRow>
        <h3 margin="bottom">
          <TextHeading margin>Interim Results</TextHeading>
        </h3>
        <GridRow cols="2">
          <GridCol>
            <CardMedia
              doclink="pdf-link-here"
              title="Half Year Results Webcast"
              type="Download PDF"
            />
          </GridCol>
          <GridCol>
            <CardMedia doclink="video-link-here" title="Half Year Results Webcast" type="Watch"/>
          </GridCol>
        </GridRow>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import CardMedia from '../components/CardMedia.vue'
import GridCol from '../elements/GridCol.vue'
import GridRow from '../elements/GridRow.vue'
import TextHeading from '../elements/TextHeading.vue'
import TheFilter from '../components/TheFilter.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import CardDownload from '../components/CardDownload.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import PageHeader from '../components/PageHeader.vue'
import SharePriceBar from '../components/SharePriceBar.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PagePresentations',
  components: {
    TheHeader,
    BreadcrumbBar,
    SharePriceBar,
    PageHeader,
    TextHeading,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    PageMain,
    TextProse,
    TheFilter,
    GridRow,
    GridCol,
    CardMedia,
    TheFooter
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  }
}
</script>